import { RouteObject, Navigate } from "react-router-dom";
import LoginPage from "@/pages/login/page";
import ForgotPasswordPage from "@/pages/forgot-password/page";
import WarehouseOpsHomePage from "@/pages/warehouse-ops/page";
import OpsPutawayPage from "@/pages/warehouse-ops/putaway";
import OpsPickPage from "@/pages/warehouse-ops/pick";
import OpsRelocatePage from "@/pages/warehouse-ops/relocate";
import RequireAuth from "@/components/feature/RequireAuth";
import NotFound from "@/pages/NotFound";

/**
 * Bản mobile của MVP là máy cầm tay trong kho, và chỉ có ba việc:
 * cất hàng vào ô, lấy hàng cho phiếu xuất, luân chuyển giữa các ô.
 *
 * Mọi việc bắt đầu từ màn chọn kho ở "/receiving" — giữ nguyên đường dẫn cũ vì
 * máy quét trong kho đang lưu sẵn địa chỉ này.
 *
 * Các nghiệp vụ khác không có trên máy cầm tay: lập phiếu, duyệt phiếu và nhận
 * hàng theo đơn mua đều làm trên máy tính. Màn nhận hàng cũ
 * (src/pages/receiving) và các màn hình của hệ thống cửa hàng trước đây
 * (check-stock, claim, destroy, order...) vẫn còn trong src/pages để tham
 * chiếu nhưng không được định tuyến tới.
 */
const routes: RouteObject[] = [
  { path: "/", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },

  // Chọn kho rồi chọn việc. Phiên chết là về thẳng màn đăng nhập, không để
  // người cầm máy thao tác rồi mới báo lỗi ở bước quét.
  { path: "/receiving", element: <RequireAuth><WarehouseOpsHomePage /></RequireAuth> },
  { path: "/warehouse-ops", element: <Navigate to="/receiving" replace /> },
  { path: "/warehouse-ops/putaway", element: <RequireAuth><OpsPutawayPage /></RequireAuth> },
  { path: "/warehouse-ops/pick", element: <RequireAuth><OpsPickPage /></RequireAuth> },
  { path: "/warehouse-ops/relocate", element: <RequireAuth><OpsRelocatePage /></RequireAuth> },

  // Đường dẫn cũ: đưa về đúng màn tương ứng thay vì báo lỗi.
  { path: "/putaway", element: <Navigate to="/warehouse-ops/putaway" replace /> },
  { path: "/stores", element: <Navigate to="/receiving" replace /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
